module.exports = __webpack_public_path__ + "static/images/callout_2.3a779795100d7550a708919e8bd3d71b.jpg";